import { ca } from '@cian/analytics';

import { getProductsData } from '../../../selectors/analytics';
import { IPromo } from '../../../types/newbuilding/promos';

export function trackGetOnlineClick(promo: IPromo, position: number, newbuildingId: number) {
  const { promoType, uniquePromoId: promoCianMortgage, promoId } = promo;

  ca('eventSite', {
    action: 'click_get_online',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId, promoCianMortgage, position })],
  });
}
